// YouTube helpers — enforce autoplay across the site
// Autoplay requires `mute=1` in most browsers, and `playsinline=1` for mobile.

const AUTOPLAY_PARAMS = "autoplay=1&mute=1&playsinline=1&rel=0";

// Convert any YouTube URL (watch/embed/short/youtu.be) into an autoplaying embed URL
export function youtubeAutoplayEmbed(url) {
  if (!url) return null;
  const m = String(url).match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]+)/);
  if (!m) return null;
  return `https://www.youtube.com/embed/${m[1]}?${AUTOPLAY_PARAMS}`;
}

// Rewrite YouTube iframes inside an HTML string to force autoplay.
export function injectAutoplayInHtml(html) {
  if (!html) return html;
  return String(html).replace(/<iframe([^>]*?)src=(["'])([^"']*youtube(?:-nocookie)?\.com\/embed\/[^"']*)\2([^>]*)>/gi,
    (_full, before, quote, src, after) => {
      let newSrc = src;
      // Strip an existing autoplay/mute so we can re-append cleanly
      newSrc = newSrc.replace(/[?&]autoplay=\d/gi, "").replace(/[?&]mute=\d/gi, "").replace(/[?&]playsinline=\d/gi, "");
      newSrc += (newSrc.includes("?") ? "&" : "?") + AUTOPLAY_PARAMS;
      // Ensure the iframe carries allow="autoplay" so the browser respects it
      let attrs = before + after;
      if (!/\ballow=/i.test(attrs)) {
        attrs += ' allow="autoplay; encrypted-media; picture-in-picture"';
      } else if (!/autoplay/i.test(attrs.match(/allow=(["'])([^"']*)\1/i)?.[2] || "")) {
        attrs = attrs.replace(/allow=(["'])([^"']*)\1/i, (_a, q, val) => `allow=${q}autoplay; ${val}${q}`);
      }
      return `<iframe${attrs} src=${quote}${newSrc}${quote}>`;
    });
}
